module.exports = __webpack_public_path__ + "img/57.8680f98d.jpg";